import { gql } from '@apollo/client';

export const CORE_USER_FIELDS = gql`
  fragment CoreUserFields on User {
    _id
    firstName
    lastName
    name
    userType
    roles
    organizationId
    suspensionId
    createdAt
    preferredLocale
  }
`;
